import { defineEvent } from '../types/event';
export var FPD_FEATURES_LIST_CLICK = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_On_FPD_Features_List'
        }
    ]
});
